import { useDrawDetails } from "../../context/draw-details";
import styles from "./styles";

export const Gallery = () => {
  const [state] = useDrawDetails();
  const productImages = state?.content?.productImages ?? [];
  return (
    <div className={styles.wrapper}>
      {productImages &&
        productImages.map((productImage) => (
          <img
            key={productImage.alt}
            src={productImage.src}
            height={productImage.height}
            width={productImage.width}
            alt={productImage.alt}
          />
        ))}
    </div>
  );
};
